export default __webpack_public_path__ + "static/media/the-time-machine.bf15d14d.png";